import React from "react";
import { cn } from "@/lib/utils";
import { brands } from "@/lib/mock-data";

/**
 * BrandLogo — a stylised wordmark chip for each brand (no real corporate logos).
 * Uses the brand's accent colour from the seed data plus the brand initial.
 * Feels intentional, not generic.
 */
export function BrandLogo({ brandId, brand: brandObj, size = "md", showName = false, className }) {
  const brand = brandObj || brands.find((b) => b.id === brandId);
  if (!brand) return null;

  const sz = {
    xs: { w: 24, h: 24, txt: "text-[10px]" },
    sm: { w: 32, h: 32, txt: "text-[12px]" },
    md: { w: 40, h: 40, txt: "text-[14px]" },
    lg: { w: 56, h: 56, txt: "text-h3" },
  }[size];

  const initial = brand.name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("");

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <div
        style={{ width: sz.w, height: sz.h, backgroundColor: brand.accent }}
        className={cn("shrink-0 rounded-md flex items-center justify-center text-white font-bold", sz.txt)}
      >
        {initial}
      </div>
      {showName && (
        <div className="flex flex-col">
          <span className="text-h4 text-ink font-semibold leading-tight">{brand.name}</span>
          <span className="text-caption text-ink-subtle">{brand.category}</span>
        </div>
      )}
    </div>
  );
}

export default BrandLogo;
